/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const formatDate = (dateStr) => {
    const dateParts = dateStr.split('/');
    if (dateParts.length === 3) {
        // Assuming format is DD/MM/YYYY
        return new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
    } else {
        // Assuming ISO format YYYY-MM-DD
        return new Date(dateStr);
    }
};

const { state } = store("gt/thelis", {
    state:{
        selectedIdStay: null,
        get currentDisponibilites(){
            const context = getContext();
            const { idsProduct } = context;
            const { stays } = state;

            if (!stays || !(idsProduct in stays) || stays[idsProduct].length === 0) {
                
                return [];
            }

            else{
                const Arrival = formatDate(Cookies.get('gtArrival'));
                const Departure = formatDate(Cookies.get('gtDeparture'));

                const disponibilites = stays[idsProduct].filter(stay => {
                    const beginDate = formatDate(stay.idStay.beginDate.split('T')[0]);
                    const endDate = formatDate(stay.idStay.endDate.split('T')[0]);
                    return beginDate.getTime() === Arrival.getTime() && endDate.getTime() === Departure.getTime();
                });

                if(disponibilites.length > 0) return disponibilites;

                const contrepropositions = stays[idsProduct].filter(stay => {
                    const beginDate = formatDate(stay.idStay.beginDate.split('T')[0]);
                    const endDate = formatDate(stay.idStay.endDate.split('T')[0]);
                    return beginDate.getTime() !== Arrival.getTime() || endDate.getTime() !== Departure.getTime();
                });

                if (contrepropositions.length > 5) {
                    contrepropositions.length = 5;
                }

                return contrepropositions;
            }


        },
        get mainStay(){
            const { currentDisponibilites, selectedIdStay } = state;
            if(selectedIdStay) return currentDisponibilites.find(stay => stay.gt.uniqueStayId === selectedIdStay);
            return currentDisponibilites[0];
        },
        get statut(){

            const Arrival = formatDate(Cookies.get('gtArrival'));
            const Departure = formatDate(Cookies.get('gtDeparture'));
            const { mainStay } = state

            if(!mainStay) return 'indisponible';

            const beginDate = formatDate(mainStay.idStay.beginDate.split('T')[0]);
            const endDate = formatDate(mainStay.idStay.endDate.split('T')[0]);
            if(beginDate.getTime() === Arrival.getTime() && endDate.getTime() === Departure.getTime()) return 'disponible';
            
            return 'contreproposition';

        },
        get titre(){
            const { statut } = state;
            if(statut === 'disponible') return state.titres.disponible;
            if(statut === 'contreproposition') return state.titres.contreproposition;
            return state.titres.indisponible;
        },
        get hasPromo(){
            const { mainStay } = state;
            return mainStay && mainStay.promotion;
        },
        get isContreproposition(){
            const { statut } = state;
            return statut === 'contreproposition';
        },
        get isIndisponible(){
            const { statut } = state;
            return statut === 'indisponible';
        }
    },
    actions: {
        loadStays : () => {
            state.selectedIdStay = null;
        },
        setMainStay: () => {
            const element = getElement();
            const context = getContext();
            const idStay = element.attributes.id;
            state.selectedIdStay = idStay;
        }
    }
});
